module.exports = __webpack_public_path__ + "img/resource-tech-image-36.c66cdc60.jpg";